import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon, SearchXIcon, DollarSignIcon, ClockIcon, LibraryIcon, TrendingUpIcon, BrainIcon } from 'lucide-react';
export function PainSolutionSection() {
  return <section className="py-24 bg-gray-50" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="text-center mb-16" data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-navy mb-4" data-id="element-96">
            Tu Atajo al Conocimiento Exponencial
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-97">
            Deja de gastar fortunas en libros individuales. Reúne todo el saber
            que necesitas en un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-98">
          {/* Pain Points */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-red-100" data-id="element-99">
            <div className="flex items-center gap-3 mb-8" data-id="element-100">
              <XCircleIcon className="text-red-500 w-8 h-8" data-id="element-101" />
              <h3 className="text-2xl font-display font-bold text-gray-900" data-id="element-102">
                El Problema
              </h3>
            </div>

            <ul className="space-y-6" data-id="element-103">
              <li className="flex items-start gap-4" data-id="element-104">
                <div className="bg-red-50 p-2 rounded-lg mt-1" data-id="element-105">
                  <DollarSignIcon className="text-red-500 w-5 h-5" data-id="element-106" />
                </div>
                <div data-id="element-107">
                  <h4 className="font-semibold text-gray-900" data-id="element-108">
                    Libros Individuales Costosos
                  </h4>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-109">
                    Comprar libros uno por uno cuesta entre $15 y $30 cada uno.
                    Una biblioteca de este tamaño costaría miles.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-110">
                <div className="bg-red-50 p-2 rounded-lg mt-1" data-id="element-111">
                  <SearchXIcon className="text-red-500 w-5 h-5" data-id="element-112" />
                </div>
                <div data-id="element-113">
                  <h4 className="font-semibold text-gray-900" data-id="element-114">
                    Información Dispersa
                  </h4>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-115">
                    Buscar los libros correctos entre millones de opciones de
                    baja calidad es agotador y frustrante.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-116">
                <div className="bg-red-50 p-2 rounded-lg mt-1" data-id="element-117">
                  <ClockIcon className="text-red-500 w-5 h-5" data-id="element-118" />
                </div>
                <div data-id="element-119">
                  <h4 className="font-semibold text-gray-900" data-id="element-120">
                    Tiempo Perdido Buscando
                  </h4>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-121">
                    Horas buscando PDFs, lidiando con enlaces rotos y archivos
                    incompletos.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>

          {/* Solution */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-navy rounded-2xl p-8 shadow-xl border border-brand-emerald/30 relative overflow-hidden" data-id="element-122">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-emerald/10 rounded-full blur-3xl" data-id="element-123"></div>

            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-124">
              <CheckCircle2Icon className="text-brand-emerald w-8 h-8" data-id="element-125" />
              <h3 className="text-2xl font-display font-bold text-white" data-id="element-126">
                La Solución Todo-en-Uno
              </h3>
            </div>

            <ul className="space-y-6 relative z-10" data-id="element-127">
              <li className="flex items-start gap-4" data-id="element-128">
                <div className="bg-brand-emerald/20 p-2 rounded-lg mt-1" data-id="element-129">
                  <LibraryIcon className="text-brand-emerald w-5 h-5" data-id="element-130" />
                </div>
                <div data-id="element-131">
                  <h4 className="font-semibold text-white" data-id="element-132">Mega Pack </h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-133">
                    +3,700 libros seleccionados y organizados por categoría para
                    acceso inmediato.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-134">
                <div className="bg-brand-emerald/20 p-2 rounded-lg mt-1" data-id="element-135">
                  <TrendingUpIcon className="text-brand-emerald w-5 h-5" data-id="element-136" />
                </div>
                <div data-id="element-137">
                  <h4 className="font-semibold text-white" data-id="element-138">Valor Imbatible</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-139">
                    Obtén toda una vida de material de lectura por menos del
                    costo de un almuerzo.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-140">
                <div className="bg-brand-emerald/20 p-2 rounded-lg mt-1" data-id="element-141">
                  <BrainIcon className="text-brand-emerald w-5 h-5" data-id="element-142" />
                </div>
                <div data-id="element-143">
                  <h4 className="font-semibold text-white" data-id="element-144">
                    Crecimiento Acelerado
                  </h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-145">
                    Domina cualquier tema al instante. Ten el mejor conocimiento
                    del mundo al alcance de tu mano 24/7.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}